import { render, staticRenderFns } from "./UserGroupFilter.vue?vue&type=template&id=63df20b0&scoped=true&"
import script from "./UserGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./UserGroupFilter.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupFilter.vue?vue&type=style&index=0&id=63df20b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df20b0",
  null
  
)

export default component.exports